export default (_atts) => ({
    formData: {
        url: _atts.url,
        product_id: _atts.product_id,
        quantity: _atts.quantity,
        csrf_token: _atts.csrf_token,
    },
    loading: false,
    productAdded: false,
    isError: false,

    submitData() {
        this.loading = true

        fetch(this.formData.url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                product_id: this.formData.product_id,
                quantity: this.formData.quantity,
                _token: this.formData.csrf_token
            })
        })
        .then((data) => {
            if(data.error) {

                this.loading = false
                this.productAdded = false
                this.isError = true
                console.error('Error while adding product to cart : ' + data.error)

            } else {

                this.loading = false
                this.productAdded = true
                Livewire.emit('productAdded')
            }
        })
        .catch((e) => {
            this.loading = false
            this.productAdded = false
            this.isError = true

            console.error('Error while adding product to cart : ' + e.getMessage())
        })

    }
})